"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMockResolvers = exports.purchaseResolver = exports.csrfResolver = exports.pageResolver = exports.mockTypeDefs = void 0;
const constants_1 = require("../../constants");
const models_1 = require("../../models");
exports.mockTypeDefs = `
schema { 
  query: Query 
  mutation: Mutation   
}
enum DeviceType {
  MOBILE
  TABLET
  DESKTOP
}
enum PageType {
  DETAIL_PAGE
  THANK_YOU_PAGE
  PURCHASE_PAGE
}
enum Tenant {
  ALEXA
  APPSTORE
}
enum PlatformType {
  IOS
  ANDROID
  DESKTOP
}
type HelloWorld {
  text: String!
}
type Mutation {
  purchase(asin: String!, marketplaceId: String!, locale: String!): Order
  action(
    asin: String
    tenant: Tenant!
    marketplaceId: String!
    actionType: String!
    data: String!
  ): ActionResponse
}
type Order {
  orderId: String!
}
type ActionResponse {
  response: String!
}
type Page {
  componentDefinitionString: String!
  tenant: Tenant
  shoppingPortalConfig: ShoppingPortalConfig
}
type ShoppingPortalConfig {
  navStoreName: String
  navNodeId: String
}
type Csrf {
  csrfToken: String
}
type Query {
  hello(name: String): HelloWorld
  page(
    asin: String
    customerId: String
    deviceType: DeviceType!
    locale: String!
    marketplaceId: String!
    pageType: PageType!
    platformType: PlatformType
  ): Page
  csrf: Csrf
}
`;
const pageResolver = (args) => {
    const { deviceType } = args;
    const detailPageComponentDefinition = constants_1.ENV_PAGE === 'slj'
        ? alexaMonetizedSkillsDetailPageComponentDefinition
        : deviceType === 'MOBILE'
            ? alexaFreeSkillsDetailPageMobileComponentDefinition
            : alexaFreeSkillsDetailPageDesktopComponentDefinition;
    const thankYouPageComponentDefinition = constants_1.ENV_PAGE === 'slj'
        ? thankYouPageComponentDefinitionV1
        : deviceType === 'MOBILE'
            ? thankYouPageComponentDefinitionV2Mobile
            : thankYouPageComponentDefinitionV2;
    return {
        componentDefinitionString: () => {
            return args.pageType === models_1.PageType.ThankYouPage
                ? JSON.stringify(thankYouPageComponentDefinition)
                : JSON.stringify(detailPageComponentDefinition);
        },
        shoppingPortalConfig: { navNodeId: 'mock_nav_node_id', navStoreName: 'mock_nav_store_name' },
        tenant: () => 'ALEXA'
    };
};
exports.pageResolver = pageResolver;
const csrfResolver = () => ({
    csrfToken: () => 'mocked-csrf-response-token'
});
exports.csrfResolver = csrfResolver;
const purchaseResolver = () => ({
    orderId: () => 'MOCK-ORDER-ID'
});
exports.purchaseResolver = purchaseResolver;
const getMockResolvers = () => ({
    Query: {
        page: (_parent, args, _context, _info) => (0, exports.pageResolver)(args),
        csrf: () => (0, exports.csrfResolver)()
    },
    Mutation: {
        purchase: (_asin, _marketplaceId, _locale) => (0, exports.purchaseResolver)()
    }
});
exports.getMockResolvers = getMockResolvers;
const thankYouPageComponentDefinitionV2Mobile = {
    id: 'canvas-container',
    children: [
        {
            id: 'canvas-container',
            state: {
                width: '100%',
                margin: '10px 0px 0px 0px',
                padding: '0px 12px',
                direction: 'column'
            },
            children: [
                {
                    id: 'canvas-container',
                    state: {
                        item: 'true',
                        margin: '.5rem 0rem'
                    },
                    children: [
                        {
                            id: 'order-confirmation'
                        },
                        {
                            id: 'order-confirmation-details'
                        },
                        {
                            id: 'order-fulfillment'
                        }
                    ]
                }
            ]
        }
    ]
};
const thankYouPageComponentDefinitionV2 = {
    id: 'canvas-container',
    state: {
        direction: 'column'
    },
    children: [
        {
            id: 'canvas-container',
            state: {
                direction: 'column',
                margin: '24px auto',
                height: '500px',
                padding: '16px 16px',
                maxWidth: '96%',
                minWidth: '1000px',
                backgroundColor: '#E3E6E6',
                borderRadius: '8px'
            },
            children: [
                {
                    id: 'canvas-container',
                    state: {
                        border: 'groove',
                        direction: 'column',
                        margin: '16px auto',
                        maxWidth: '96%',
                        minWidth: '900px',
                        height: '500px',
                        backgroundColor: '#FFFFFF',
                        borderRadius: '8px'
                    },
                    children: [
                        {
                            id: 'canvas-container',
                            state: {
                                direction: 'column',
                                margin: '16px auto',
                                width: '49%',
                                height: '400px',
                                wrap: 'nowrap'
                            },
                            children: [
                                {
                                    id: 'canvas-item',
                                    state: {
                                        direction: 'column',
                                        width: '100%',
                                        height: '150px',
                                        padding: '16px 0px 0px 48px',
                                        wrap: 'nowrap'
                                    },
                                    children: [
                                        {
                                            id: 'order-confirmation',
                                            state: {
                                                orderPlaced: 'Order placed, thanks!',
                                                orderReview: 'Confirmation will be sent to your email.'
                                            }
                                        }
                                    ]
                                },
                                {
                                    id: 'divider'
                                },
                                {
                                    id: 'canvas-item',
                                    _comment: 'TODO: remove borders, fix size adjustment when data is populated',
                                    state: {
                                        direction: 'column',
                                        width: '100%',
                                        height: '250px',
                                        wrap: 'nowrap'
                                    },
                                    children: [
                                        {
                                            id: 'order-confirmation-details'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            id: 'canvas-item',
                            _comment: 'TODO: remove borders',
                            state: {
                                border: '1px solid',
                                direction: 'column',
                                margin: '16px auto',
                                width: '49%',
                                height: '400px',
                                wrap: 'nowrap'
                            },
                            children: [
                                {
                                    id: 'order-fulfillment'
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
};
const thankYouPageComponentDefinitionV1 = {
    id: 'canvas-container',
    state: {
        direction: 'column',
        padding: '16px 16px 0px 16px',
        margin: '0 auto',
        maxWidth: '1260px',
        minWidth: '940px'
    },
    children: [
        {
            id: 'alexa-monetized-skill-thank-you-details',
            state: {
                developerName: 'Amazon',
                imageUrl: 'https://images-na.ssl-images-amazon.com/images/I/71RF6ia9xmL.png',
                titleCopy: 'Samuel L. Jackson–celebrity personality for Alexa',
                youHavePurchasedCopy: 'You hve purchased:',
                thanksCopy: 'Thanks!',
                byCopy: 'by',
                viewYourCopy: 'View your',
                orderDetailsCopy: 'order details.',
                wheresMyProductCopy: "Where's my product?",
                toUseCopy: 'To use',
                launchSkillCopy: 'launch the skill on an Alexa Device.',
                learnMoreCopy: 'Learn more about Alexa skill',
                orderDetailsUrl: 'https://www.amazon.com/gp/digital/your-account/order-summary.html?orderID=D01-3074666-8445023&ref=a2s_ty',
                learnMoreUrl: 'https://www.amazon.com/gp/help/customer/display.html?nodeId=201848700&ref=a2s_ty',
                productHref: 'https://localhost.amazon.com:9080/dp/SAMJACKSON'
            }
        }
    ]
};
const alexaFreeSkillsDetailPageDesktopComponentDefinition = {
    id: 'store-container',
    state: {},
    children: [
        {
            id: 'canvas-container',
            state: {
                direction: 'column'
            },
            children: [
                {
                    id: 'alexa-free-skill-meta-tag',
                    state: {
                        productTitle: 'Sleep Sounds by Sleep Jar®',
                        description: 'Sleep Sounds by Sleep Jar®',
                        pageTitle: 'Amazon.com: Sleep Sounds by Sleep Jar® : Alexa Skills',
                        imageUrl: 'https://images-na.ssl-images-amazon.com/images/I/51-nklKf-PL.png'
                    }
                },
                {
                    id: 'canvas-container',
                    state: {
                        padding: '14px 18px'
                    },
                    children: [
                        {
                            id: 'breadcrumbs',
                            state: {
                                breadcrumbs: [
                                    {
                                        name: 'Alexa Skills',
                                        url: '/b?node=13727921011'
                                    },
                                    {
                                        name: 'Novelty & Humor',
                                        url: '/b?node=14284858011'
                                    }
                                ]
                            }
                        }
                    ]
                },
                {
                    id: 'canvas-container',
                    state: {
                        direction: 'column',
                        padding: '16px 16px 0px 16px',
                        margin: '0 auto',
                        maxWidth: '1260px',
                        minWidth: '780px'
                    },
                    children: [
                        {
                            id: 'free-skill-alert-banner-group',
                            state: {
                                alertMessages: [
                                    {
                                        alertTitleText: 'Alert Banner',
                                        alertText: 'This is the alert banner, hope some text appears here',
                                        alertBannerType: 'success'
                                    }
                                ]
                            }
                        },
                        {
                            id: 'canvas-container',
                            state: {
                                margin: '10px 0px 0px 0px',
                                wrap: 'nowrap'
                            },
                            children: [
                                {
                                    id: 'canvas-item',
                                    children: [
                                        {
                                            id: 'alexa-free-skill-logo',
                                            state: {
                                                imageWidth: '210px',
                                                imageMinWidth: '210px',
                                                altText: 'Sleep Sounds by Sleep Jar®',
                                                imageUrl: 'https://images-na.ssl-images-amazon.com/images/I/51-nklKf-PL.png',
                                                imageMargin: '0px 20px 20px 0px',
                                                title: 'Sleep Sounds by Sleep Jar®',
                                                imageHeight: '210px'
                                            }
                                        }
                                    ]
                                },
                                {
                                    id: 'canvas-container',
                                    state: {
                                        item: true,
                                        xs: true,
                                        maxWidth: '730px',
                                        minWidth: '230px',
                                        margin: '0px 20px 0px 0px'
                                    },
                                    children: [
                                        {
                                            id: 'canvas-container',
                                            state: {
                                                margin: '0px 0px 0px 10px',
                                                direction: 'column',
                                                item: true,
                                                xs: true
                                            },
                                            children: [
                                                {
                                                    id: 'free-skill-title',
                                                    state: {
                                                        title: 'Sleep Sounds by Sleep Jar®'
                                                    }
                                                },
                                                {
                                                    id: 'free-skill-publisher',
                                                    state: {
                                                        publisher: 'Sleep Jar',
                                                        byText: 'by'
                                                    }
                                                },
                                                {
                                                    id: 'free-skill-maturity-rating',
                                                    state: {
                                                        modalDescriptionList: [
                                                            'Account linking',
                                                            'Advertisements',
                                                            'User-generated content',
                                                            'Personal information collection',
                                                            'Location detection or location-based services',
                                                            'Nudity or descriptions of nudity within medical, informational or artistic contexts',
                                                            'Infrequent or mild references to cultural or religious intolerance',
                                                            'Infrequent or mild realistic, cartoon, or fantasy violence or descriptions of violence',
                                                            'Infrequent or mild references to alcohol, tobacco and drugs',
                                                            'Infrequent or mild sexual and suggestive themes',
                                                            'Infrequent use of mild profanity and crude humor',
                                                            'Music and video skills may occasionally include strong profanity and sexual or suggestive themes'
                                                        ],
                                                        ratedCopy: 'Rated',
                                                        modalHeaderCopy: 'Rating Definitions',
                                                        modalIntroCopy: 'The content of this skill is appropriate for most users. This skill may include:',
                                                        modalButtonCopy: 'I understand',
                                                        maturityRating: 'Guidance Suggested'
                                                    }
                                                },
                                                {
                                                    id: 'average-customer-reviews',
                                                    state: {
                                                        averageOverallRating: '4.1',
                                                        reviewsFontSize: '12px',
                                                        totalRatingCount: '5113',
                                                        reviewHref: '/product-reviews/SLEEPSOUND'
                                                    }
                                                },
                                                {
                                                    id: 'free-to-enable',
                                                    state: {
                                                        copy: 'Free to Enable'
                                                    }
                                                },
                                                {
                                                    id: 'in-skill-purchases-available',
                                                    state: {
                                                        inSkillPurchaseCopy: 'In-Skill Purchases Available',
                                                        textProps: {
                                                            fontFamily: 'verdana,arial,helvetica,sans-serif'
                                                        },
                                                        isHyperLink: true,
                                                        hasInSkillPurchases: true,
                                                        isCenterAligned: false
                                                    }
                                                },
                                                {
                                                    id: 'utterance-bubbles-desktop',
                                                    state: {
                                                        defaultLocale: 'en-US',
                                                        utterancesByLocale: {
                                                            'de-DE': [
                                                                '„Alexa, starte Einschlafgeräusche”',
                                                                '„Alexa, frage Einschlafgeräusche nach Regenschauer”',
                                                                '„Alexa, spiele Ozeanwellen von Einschlafgeräusche”'
                                                            ],
                                                            'en-US': [
                                                                '”Alexa, open Sleep Sounds”',
                                                                '”Alexa, ask Sleep Sounds for thunderstorms”',
                                                                '”Alexa, ask Sleep Sounds for a list”'
                                                            ],
                                                            'en-CA': [
                                                                '”Alexa, open Sleep Sounds”',
                                                                '”Alexa, ask Sleep Sounds for thunderstorms”',
                                                                '”Alexa, ask Sleep Sounds for a list”'
                                                            ],
                                                            'pt-BR': [
                                                                '“Alexa, abra Sons para Dormir”',
                                                                '“Alexa, fale com Sons para Dormir para tocar tempestade”',
                                                                '“Alexa, abre Sons para Dormir para uma lista”'
                                                            ],
                                                            'en-IN': [
                                                                '”Alexa, open Sleep Sounds”',
                                                                '”Alexa, ask Sleep Sounds for thunderstorms”',
                                                                '”Alexa, ask Sleep Sounds for a list”'
                                                            ],
                                                            'es-ES': [
                                                                '“Alexa, abre Sonidos para Dormir”',
                                                                '“Alexa, pide a Sonidos para Dormir lluvia”',
                                                                '“Alexa, pide a Sonidos para Dormir una lista”'
                                                            ],
                                                            'es-MX': [
                                                                '“Alexa, abre Sonidos para Dormir”',
                                                                '“Alexa, pide a Sonidos para Dormir lluvia”',
                                                                '“Alexa, pide a Sonidos para Dormir una lista”'
                                                            ],
                                                            'fr-CA': [
                                                                '« Alexa, lance Sons Sommeil »',
                                                                '« Alexa, demande à Sons Sommeil de jouer des orages »',
                                                                '« Alexa, ouvre Sons Sommeil »'
                                                            ],
                                                            'it-IT': [
                                                                '”Alexa, apri Rumori per Dormire”',
                                                                '”Alexa, domanda a Rumori per Dormire di farmi sentire i temporali”',
                                                                '”Alexa, chiedi a Rumori per Dormire un elenco”'
                                                            ],
                                                            'en-AU': [
                                                                '”Alexa, open Sleep Sounds”',
                                                                '”Alexa, ask Sleep Sounds for thunderstorms”',
                                                                '”Alexa, ask Sleep Sounds for a list”'
                                                            ],
                                                            'es-US': [
                                                                '”Alexa, abre Sonidos para Dormir”',
                                                                '”Alexa, pide a Sonidos para Dormir lluvia”',
                                                                '”Alexa, pide a Sonidos para Dormir una lista”'
                                                            ],
                                                            'fr-FR': [
                                                                '« Alexa, lance Sons Sommeil »',
                                                                '« Alexa, demande à Sons Sommeil de jouer des orages »',
                                                                '« Alexa, ouvre Sons Sommeil »'
                                                            ],
                                                            'en-GB': [
                                                                '”Alexa, open Sleep Sounds”',
                                                                '”Alexa, ask Sleep Sounds for thunderstorms”',
                                                                '”Alexa, ask Sleep Sounds for a list”'
                                                            ],
                                                            'ja-JP': [
                                                                '「アレクサ、睡眠の音を開いて」',
                                                                '「アレクサ、睡眠の音をスタートして」',
                                                                '「アレクサ、睡眠の音を実行して」'
                                                            ]
                                                        },
                                                        shownInCopy: 'Shown in:',
                                                        languagesByLocale: {
                                                            'en-AU': 'English (AU)',
                                                            'en-CA': 'English (CA)',
                                                            'en-GB': 'English (GB)',
                                                            'en-IN': 'English (IN)',
                                                            'en-US': 'English (US)',
                                                            'fr-CA': 'French (CA)',
                                                            'fr-FR': 'French (FR)',
                                                            'de-DE': 'German (DE)',
                                                            'it-IT': 'Italian (IT)',
                                                            'ja-JP': 'Japanese (JP)',
                                                            'pt-BR': 'Portuguese (BR)',
                                                            'es-ES': 'Spanish (ES)',
                                                            'es-MX': 'Spanish (MX)',
                                                            'es-US': 'Spanish (US)'
                                                        },
                                                        seeAllSupportedLanguagesCopy: 'See all supported languages'
                                                    }
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    id: 'canvas-container',
                                    state: {
                                        direction: 'column',
                                        width: 'auto',
                                        item: true
                                    },
                                    children: [
                                        {
                                            id: 'free-skill-buy-box',
                                            state: {
                                                error: 'BuyBoxModel is null'
                                            }
                                        },
                                        {
                                            id: 'alexa-skill-share',
                                            state: {
                                                shareViaEmailLabel: 'Share via e-mail',
                                                shareViaTwitterLabel: 'Share on Twitter',
                                                subject: 'You might be interested in this Alexa skill from Amazon.',
                                                imageUrl: 'https://images-na.ssl-images-amazon.com/images/I/51-nklKf-PL.png',
                                                shareUrl: 'https://www.amazon.com/dp/SLEEPSOUND',
                                                message: 'I thought you might be interested in this Alexa skill.',
                                                shareViaFacebookLabel: 'Share on Facebook',
                                                shareViaPinterestLabel: 'Pin it on Pinterest'
                                            }
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            id: 'canvas-container',
                            state: {
                                margin: '10px 0px 22px 0px',
                                borderTop: '1px solid #e7e7e7',
                                padding: '14px 0px 0px 0px'
                            },
                            children: [
                                {
                                    id: 'free-skill-highlights',
                                    state: {
                                        titleCopy: 'Skill Highlights',
                                        showPaginationButtons: true,
                                        deviceType: 'DESKTOP',
                                        mediaWidgetProps: [
                                            {
                                                mediaSrcType: 1,
                                                mediaUrl: 'https://images-na.ssl-images-amazon.com/images/I/41Id9W41ZWS.jpg'
                                            },
                                            {
                                                mediaSrcType: 1,
                                                mediaUrl: 'https://images-na.ssl-images-amazon.com/images/I/41Id9W41ZWS.jpg'
                                            },
                                            {
                                                mediaSrcType: 1,
                                                mediaUrl: 'https://images-na.ssl-images-amazon.com/images/I/41Id9W41ZWS.jpg'
                                            },
                                            {
                                                mediaSrcType: 1,
                                                mediaUrl: 'https://images-na.ssl-images-amazon.com/images/I/41Id9W41ZWS.jpg'
                                            },
                                            {
                                                mediaSrcType: 1,
                                                mediaUrl: 'https://images-na.ssl-images-amazon.com/images/I/41Id9W41ZWS.jpg'
                                            },
                                            {
                                                mediaSrcType: 2,
                                                mediaUrl: 'https://images-na.ssl-images-amazon.com/images/I/F1ylf204aZS.mp4',
                                                featureFrameUrl: 'https://drive.corp.amazon.com/view/kusharju@/CR_Images/StoryBook/Alexa_Logo.png'
                                            }
                                        ],
                                        videosTabTitleCopy: 'VIDEOS',
                                        imagesTabTitleCopy: 'IMAGES',
                                        skillTitleCopy: 'Sleep Sounds',
                                        skillDeveloperNameCopy: 'Sleep Jar',
                                        byTextCopy: 'by',
                                        videoHoverText: 'Click to see video',
                                        imageHoverText: 'Click to open expanded view'
                                    }
                                }
                            ]
                        },
                        {
                            id: 'canvas-container',
                            state: {
                                margin: '10px 0px 22px 0px',
                                borderTop: '1px solid #e7e7e7',
                                padding: '14px 0px 0px 0px'
                            },
                            children: [
                                {
                                    id: 'skill-product-description',
                                    state: {
                                        description: 'Sleep Sounds plays calming sound loops to help you fall asleep faster, sleep better, relax, meditate, or drown out distracting noises.\n\n\nHOW TO USE:\n\nGet started by saying "Alexa, open Sleep Sounds" and Alexa will ask you what sound loop you would like to hear.\n\nTo start a sound immediately or change sounds while a sound is playing, just say "Alexa, ask Sleep Sounds to play thunderstorms" or another sound of choice.\n\nFor a full list of available sounds, say "Alexa, ask Sleep Sounds for a list". Alexa will speak a list of supported sounds and place a readable list in the Alexa smartphone app.\n\nBy default, Sleep Sounds will play your selected sound until you say "Alexa, stop", but you can set a custom timer while a sound is playing by saying "Alexa, stop in 3 hours" or any other time duration.\n\nIf you\'re feeling a little adventurous, say "random" to let Sleep Sounds pick a sound for you!\n\n\nPREMIUM MEMBERSHIP FEATURES:\n\n+ Mix 2 sounds together (over 5,000 unique combinations!)\n+ 100% increase in audio quality \n+ Enhanced looping (no sound gaps for 10 hours instead of 1 hour)\n\n\nINCLUDED SOUNDS:\n\n- Thunderstorm\n- Rain\n- Ocean\n- Babbling Brook\n- Fireplace\n- Airplane\n- Fan\n- Oscillating Fan\n- City\n- Rainforest\n- Train\n- Crickets\n- Frogs\n- Bird\n- Clock\n- Cat\n- Vacuum\n- Pink Noise\n- Brown Noise\n- White Noise\n- Wind\n- Windy Leaves\n- Windy Trees\n- Rain on a Tin Roof\n- Rain on a Tent\n- Light Rain\n- Rain on a Window\n- Distant Thunderstorm\n- Shower\n- Space Deck\n- Hair Dryer\n- Clothes Dryer\n- Dishwasher\n- Wind Chimes\n- Whale\n- Windy Meadow\n- Heavy Rain\n- Dripping Water\n- Fountain\n- Waterfall\n- Forest Night\n- Washing Machine\n- Heartbeat\n- Café\n- Dream\n- Blizzard\n- Owl\n- Underwater\n- Air Conditioner\n- Cicadas\n- Ice Machine\n- Lake\n- Office\n- Seagulls\n- Womb\n- Crinkling Plastic\n- Boat Ride\n- Highway\n- Coqui Frogs\n- Loons\n- Spa\n- Tibetan Bowls\n- Binaural\n- Distant Train\n- Snoring\n- Native American Flute\n- Indian Flute\n- Gregorian Chant\n- Keyboard\n- Car Ride\n- Creaking Ship\n- Row Boat\n- Wolves\n- Music Box\n- Lullaby\n- Electric Shaver\n- Bathtub\n- Draining Water\n- Buzzing Light\n- Peaceful\n- Piano\n- India\n- Sailing\n- Harp\n- Pipe Organ\n- Medieval\n- Guitar\n- Duduk\n- Wind Tunnel\n- Flute\n- Ukulele\n- Didgeridoo\n- Cavern\n- Farm\n- Truck Engine\n- Electric Heater\n- Radiator\n- Lawn Mower\n- Panting Dog\n- Summer Day\n- Thunder\n- A Random Sound\n\n\nSOUND REQUESTS:\n\nWe offer dozens of different sounds, but if you think of one that we don\'t have yet please email us at support@sleepjar.com!\n\n\nSHOW YOUR SUPPORT:\n\nYour reviews and feedback are important to us! Please consider showing your support by writing a review for Sleep Sounds, or send us an email with your feedback at support@sleepjar.com.\n\n\nCopyright © Invoked Apps LLC dba Sleep Jar',
                                        titleCopy: 'Description',
                                        seeMoreCopy: 'See More',
                                        seeLessCopy: 'See Less'
                                    }
                                }
                            ]
                        },
                        {
                            id: 'free-skill-note',
                            state: {
                                noteTitleCopy: 'Note',
                                titleTextProps: {
                                    padding: '0px 0px 4px 0px'
                                },
                                contentTextProps: {},
                                canvasContainerProps: {
                                    margin: '0px 0px 22px 0px',
                                    borderTop: '1px solid #e7e7e7',
                                    padding: '14px 0px 0px 0px'
                                }
                            }
                        },
                        {
                            id: 'canvas-container',
                            state: {
                                margin: '10px 0px 22px 0px',
                                borderTop: '1px solid #e7e7e7',
                                padding: '14px 0px 0px 0px'
                            },
                            children: [
                                {
                                    id: 'skill-details',
                                    state: {
                                        invocationNameCopy: 'Invocation Name:',
                                        titleCopy: 'Skill Details',
                                        developerTermsOfUseCopyByLocale: {
                                            'en-US': 'Developer Terms of Use'
                                        },
                                        dynamicContentProps: {
                                            dynamicContentContains: 'This skill contains',
                                            dynamicContentWarning: 'This skill contains dynamic content, which is content that is updated real-time based on inputs from the developer. The maturity rating associated with this skill pertains only to the content of the skill at the time of the submission.',
                                            dynamicContentModalTitle: 'Dynamic Content',
                                            dynamicContentModalButtonCopy: 'I understand',
                                            dynamicContentLowerCase: 'dynamic content'
                                        },
                                        maturityRatingProps: {
                                            modalDescriptionList: [
                                                'Account linking',
                                                'Advertisements',
                                                'User-generated content',
                                                'Personal information collection',
                                                'Location detection or location-based services',
                                                'Nudity or descriptions of nudity within medical, informational or artistic contexts',
                                                'Infrequent or mild references to cultural or religious intolerance',
                                                'Infrequent or mild realistic, cartoon, or fantasy violence or descriptions of violence',
                                                'Infrequent or mild references to alcohol, tobacco and drugs',
                                                'Infrequent or mild sexual and suggestive themes',
                                                'Infrequent use of mild profanity and crude humor',
                                                'Music and video skills may occasionally include strong profanity and sexual or suggestive themes'
                                            ],
                                            ratedCopy: 'Rated',
                                            modalHeaderCopy: 'Rating Definitions',
                                            modalIntroCopy: 'The content of this skill is appropriate for most users. This skill may include:',
                                            modalButtonCopy: 'I understand',
                                            maturityRating: 'Guidance Suggested'
                                        },
                                        invocationNameValue: 'sleep sounds',
                                        developerPrivacyPolicyCopyByLocale: {
                                            'en-US': 'Developer Privacy Policy'
                                        },
                                        developerPrivacyPolicyUrlByLocale: {
                                            'en-US': 'https://sleepjar.com/privacy'
                                        },
                                        developerTermsOfUseUrlByLocale: {
                                            'en-US': 'https://sleepjar.com/terms'
                                        }
                                    }
                                }
                            ]
                        },
                        {
                            id: 'privacy',
                            state: {}
                        },
                        {
                            id: 'in-skill-purchases',
                            state: {
                                productsList: [
                                    {
                                        productTitle: 'Test Entitlement Product',
                                        productHref: '/dp/ASINENTITLEMENT?ref=skillrw_isp_dplnk',
                                        productOffer: '$1.95'
                                    },
                                    {
                                        productTitle: 'Test Consumable Product',
                                        productHref: '/dp/ASINCONSUMABLE?ref=skillrw_isp_dplnk',
                                        productOffer: 'CAD 0.00'
                                    },
                                    {
                                        productTitle: 'Test Subscription Product',
                                        productHref: '/dp/ASINSUBSCRIPTION?ref=skillrw_isp_dplnk',
                                        productOffer: 'JPY 281 every 3 weeks'
                                    }
                                ],
                                titleCopy: 'In-Skill Purchases'
                            }
                        },
                        {
                            id: 'canvas-container',
                            state: {
                                margin: '0px 0px 22px 0px',
                                borderTop: '1px solid #e7e7e7',
                                padding: '14px 0px 0px 0px'
                            },
                            children: [
                                {
                                    id: 'free-skill-supported-languages',
                                    state: {
                                        languages: [
                                            'Arabic (SA)',
                                            'English (AU)',
                                            'English (CA)',
                                            'English (GB)',
                                            'English (IN)',
                                            'English (US)',
                                            'French (CA)',
                                            'French (FR)',
                                            'German (DE)',
                                            'Italian (IT)',
                                            'Japanese (JP)',
                                            'Portuguese (BR)',
                                            'Spanish (ES)',
                                            'Spanish (MX)',
                                            'Spanish (US)'
                                        ],
                                        titleCopy: 'Supported Languages'
                                    }
                                }
                            ]
                        },
                        {
                            id: 'canvas-container',
                            state: {
                                direction: 'column'
                            },
                            children: [
                                {
                                    id: 'customer-reviews-medley',
                                    state: {
                                        html: '<a id="customerReviews" aria-label="Top reviews" class="a-link-normal" href="#"></a><hr aria-hidden="true" class="a-spacing-large a-divider-normal"/><span class="cr-widget-PageState">\n  <span id="cr-state-object" data-state=\'{"asin":"SLEEPSOUND","customerId":"0","deviceType":"desktop","contextId":"","reviewCommentsAjaxUrl":"","reviewCommentSubmissionAjaxUrl":"","approvedAuthorAjaxUrl":"","reviewsAjaxUrl":"/hz/reviews-render/ajax/medley-filtered-reviews/get/","medleyReviewsAjaxUrl":"/hz/reviews-render/ajax/medley-reviews/get/","reviewerType":"","formatType":"","filterByKeyword":"","filterByLanguage":"","filterByStar":"","filterByHeight":"","filterByWeight":"","showLanguageFilter":false,"showHeightFilter":false,"languageOfPreference":"en_US","isCardTreatmentEnabled":false,"lazyWidgetLoaderBufferPixels":"1000","lazyWidgetLoaderDelayBeforeTriggering":"5000","lazyWidgetLoaderUrl":"/hz/reviews-render/ajax/lazy-widgets/stream","lazyWidgetCsrfToken":"gsoEbM%2BbgqYo1ofe6SfeSFmc1fvTNP8XdP4ZtR0AAAABAAAAAGJm%2FS5yYXcAAAAA%2B4kUEk%2F7iMGR3xPcX6iU","lazyWidgetDomainWhitelist":["amazon.com","amazon.ca","amazon.com.mx","amazon.com.br","amazon.co.uk","amazon.de","amazon.it","amazon.sa","amazon.com.tr","amazon.es","amazon.fr","amazon.in","amazon.ae","amazon.nl","amazon.se","amazon.pl","amazon.eg","amazon.co.jp","amazon.com.au","amazon.sg","amazon.cn"],"signinUrl":"https://development.amazon.com/ap/signin?openid.return_to\\u003dhttps%3A%2F%2Fadg-lpproxysvc-beta-na-backend.integ.amazon.com%2Fproduct-reviews%2FSLEEPSOUND%3Fie%3DUTF8\\u0026openid.identity\\u003dhttp%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select\\u0026openid.claimed_id\\u003dhttp%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select\\u0026openid.assoc_handle\\u003dusflex\\u0026openid.mode\\u003dcheckid_setup\\u0026openid.ns\\u003dhttp%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0","reftagTriggerUrl":"/hz/reviews-render/ajax/reftag-trigger","mobileImageGalleryUrl":"","productInfoUrl":"","disableScroll":false,"onLoadShowHideElements":"#cm-cr-dp-reviews-loading-wrapper,.cr-reviews-loading","marketplaceId":"ATVPDKIKX0DER","locale":"en_US"}\'></span>\n</span>\n<link rel="stylesheet" href="https://images-na.ssl-images-amazon.com/images/I/01STrEog8JL._RC|015DCfR+jFL.css,01LKsGfpclL.css,31Hq2JRAgIL.css,01cdXa5nSoL.css_.css?AUIClients/DesktopMedleyFilteringMetaAsset&m0exVCZt#386124-T1.343764-T1" />\n<script>\n  (window.AmazonUIPageJS ? AmazonUIPageJS : P).load.js(\'https://images-na.ssl-images-amazon.com/images/I/41Nvm9nQjfL._RC|01HLxsL-v8L.js,11aqOtf9OsL.js,31vwrZnNosL.js,21HWbFKuvXL.js_.js?AUIClients/DesktopMedleyFilteringMetaAsset&O+xkmGCp#412745-T1.371861-T1.386124-T1\');\n</script>\n<div id="reviewsMedley" data-hook="reviews-medley-widget" class="a-fixed-left-grid a-spacing-extra-large"><div class="a-fixed-left-grid-inner" style="padding-left:300px"><div class="a-fixed-left-grid-col a-col-left" style="width:300px;margin-left:-300px;float:left;"><div class="a-row"><h2>Customer Reviews</h2></div><div class="a-section a-spacing-none a-spacing-top-mini cr-widget-ACR"></div><span class="cr-widget-Histogram">\n      <div class="a-fixed-left-grid a-spacing-none"><div class="a-fixed-left-grid-inner" style="padding-left:280px"><div class="a-fixed-left-grid-col a-col-left" style="width:280px;margin-left:-280px;float:left;"><span class="a-declarative" data-action="reviews:filter-action:push-state" data-reviews:filter-action:push-state="{&quot;scrollToSelector&quot;:&quot;#reviews-filter-info&quot;,&quot;allowLinkDefault&quot;:&quot;1&quot;}"><table id="histogramTable" class="a-normal a-spacing-none" role="presentation">\n\n\n\n\n\n\n\n\n<table id="histogramTable" class="a-normal a-align-center a-spacing-base">\n  \n\n\n\n\n\n\n\n\n\n\n\n\n\n\n  \n    \n  \n  \n\n\n\n\n\n\n\n\n\n\n\n  \n\n    \n    <tr class="a-histogram-row">\n\n      <td class="a-nowrap">\n        <span class="a-size-base">\n          5 star\n        </span>\n\n        \n        <span class="a-offscreen">\n          (0%)\n        </span>\n\n        <span class="a-letter-space"></span>\n      </td>\n\n      <td aria-hidden="true" class="a-span10">\n        <div class="a-meter" role="progressbar" aria-valuenow="0%"><div class="a-meter-bar" style="width: 0%;"></div></div>\n      </td>\n\n      <td class="a-text-right a-nowrap">\n        <span class="a-letter-space"></span>\n\n        <span class="a-size-base">\n          \n            0%\n          \n        </span>\n      </td>\n    </tr>\n\n  \n  \n\n\n  \n\n\n\n\n\n\n\n\n\n\n\n\n\n\n  \n    \n  \n  \n\n\n\n\n\n\n\n\n\n\n\n  \n\n    \n    <tr class="a-histogram-row">\n\n      <td class="a-nowrap">\n        <span class="a-size-base">\n          4 star\n        </span>\n\n        \n        <span class="a-offscreen">\n          (0%)\n        </span>\n\n        <span class="a-letter-space"></span>\n      </td>\n\n      <td aria-hidden="true" class="a-span10">\n        <div class="a-meter" role="progressbar" aria-valuenow="0%"><div class="a-meter-bar" style="width: 0%;"></div></div>\n      </td>\n\n      <td class="a-text-right a-nowrap">\n        <span class="a-letter-space"></span>\n\n        <span class="a-size-base">\n          \n            0%\n          \n        </span>\n      </td>\n    </tr>\n\n  \n  \n\n\n  \n\n\n\n\n\n\n\n\n\n\n\n\n\n\n  \n    \n  \n  \n\n\n\n\n\n\n\n\n\n\n\n  \n\n    \n    <tr class="a-histogram-row">\n\n      <td class="a-nowrap">\n        <span class="a-size-base">\n          3 star\n        </span>\n\n        \n        <span class="a-offscreen">\n          (0%)\n        </span>\n\n        <span class="a-letter-space"></span>\n      </td>\n\n      <td aria-hidden="true" class="a-span10">\n        <div class="a-meter" role="progressbar" aria-valuenow="0%"><div class="a-meter-bar" style="width: 0%;"></div></div>\n      </td>\n\n      <td class="a-text-right a-nowrap">\n        <span class="a-letter-space"></span>\n\n        <span class="a-size-base">\n          \n            0%\n          \n        </span>\n      </td>\n    </tr>\n\n  \n  \n\n\n  \n\n\n\n\n\n\n\n\n\n\n\n\n\n\n  \n    \n  \n  \n\n\n\n\n\n\n\n\n\n\n\n  \n\n    \n    <tr class="a-histogram-row">\n\n      <td class="a-nowrap">\n        <span class="a-size-base">\n          2 star\n        </span>\n\n        \n        <span class="a-offscreen">\n          (0%)\n        </span>\n\n        <span class="a-letter-space"></span>\n      </td>\n\n      <td aria-hidden="true" class="a-span10">\n        <div class="a-meter" role="progressbar" aria-valuenow="0%"><div class="a-meter-bar" style="width: 0%;"></div></div>\n      </td>\n\n      <td class="a-text-right a-nowrap">\n        <span class="a-letter-space"></span>\n\n        <span class="a-size-base">\n          \n            0%\n          \n        </span>\n      </td>\n    </tr>\n\n  \n  \n\n\n  \n\n\n\n\n\n\n\n\n\n\n\n\n\n\n  \n    \n  \n  \n\n\n\n\n\n\n\n\n\n\n\n  \n\n    \n    <tr class="a-histogram-row">\n\n      <td class="a-nowrap">\n        <span class="a-size-base">\n          1 star\n        </span>\n\n        \n        <span class="a-offscreen">\n          (0%)\n        </span>\n\n        <span class="a-letter-space"></span>\n      </td>\n\n      <td aria-hidden="true" class="a-span10">\n        <div class="a-meter" role="progressbar" aria-valuenow="0%"><div class="a-meter-bar" style="width: 0%;"></div></div>\n      </td>\n\n      <td class="a-text-right a-nowrap">\n        <span class="a-letter-space"></span>\n\n        <span class="a-size-base">\n          \n            0%\n          \n        </span>\n      </td>\n    </tr>\n\n  \n  \n\n\n</table>\n</table></span></div></div></div>\n\n\n\n\n\n\n\n<div class="a-row a-expander-container a-spacing-top-medium a-expander-inline-container">\n    \n        \n        \n            <a data-hook="cr-ratings-explanation-expand" aria-expanded="false" role="button" href="javascript:void(0)" data-action="a-expander-toggle" class="a-expander-header a-declarative a-expander-inline-header a-link-expander" data-a-expander-toggle="{&quot;allowLinkDefault&quot;:true, &quot;expand_prompt&quot;:&quot;&quot;, &quot;collapse_prompt&quot;:&quot;&quot;}"><i class="a-icon a-icon-expand"></i><span class="a-expander-prompt">\n                How are ratings calculated?\n            </span></a>\n            <div aria-expanded="false" class="a-expander-content a-expander-inline-content a-expander-inner" style="display:none">\n                To calculate the overall star rating and percentage breakdown by star, we don’t use a simple average. Instead, our system considers things like how recent a review is and if the reviewer bought the item on Amazon. It also analyzes reviews to verify trustworthiness.\n            </div>\n        \n    \n</div></span>\n    <hr aria-hidden="true" class="a-spacing-large a-spacing-top-large a-divider-normal"/><span class="cr-lazy-widget cr-summarization-attributes" data-widget-name=\'cr-summarization-attributes\'>\n</span><span class="cr-lazy-widget cr-age-recommendation" data-widget-name=\'cr-age-recommendation\'>\n</span><span class="cr-lazy-widget cr-solicitation" data-widget-name=\'cr-solicitation\'>\n</span><hr aria-hidden="true" class="a-spacing-extra-large a-spacing-top-extra-large a-divider-normal"/></div><div class="a-fixed-left-grid-col a-col-right" style="padding-left:2.5%;float:left;"><div class="a-row cm_cr_grid_center_container"><div class="a-fixed-right-grid-col cm_cr_grid_center_left" style="float:left;"></div><div class="a-fixed-right-grid-col cm_cr_grid_center_right" style="float:left;"><span class="cr-lazy-widget cr-summarization-lighthut" data-widget-name=\'cr-summarization-lighthut\'>\n</span><div id="cm-cr-dp-review-header" class="a-section a-spacing-small"><h3 class="a-spacing-small"><span data-hook="top-customer-reviews-title" class="a-size-base">No customer reviews</span></h3></div><span class="cr-widget-FocalReviews" data-hook="cr-widget-FocalReviews"></span>\n  <span class="cr-widget-DesktopGlobalReviews" data-hook="cr-widget-DesktopGlobalReviews"></span>\n  </div></div></div></div></div>'
                                    }
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
};
const alexaFreeSkillsDetailPageMobileComponentDefinition = {
    id: 'canvas-container',
    children: [
        {
            id: 'canvas-container',
            state: {
                margin: '10px 0px 0px 0px',
                padding: '0px 12px 0px 12px',
                direction: 'column'
            },
            children: [
                {
                    id: 'alexa-free-skill-meta-tag',
                    state: {
                        description: 'awesome noddy hub',
                        pageTitle: 'Amazon.com: awesome noddy hub : Alexa Skills',
                        productTitle: 'awesome noddy hub',
                        imageUrl: 'https://images-na.ssl-images-amazon.com/images/I/41ltokWUhJL.png'
                    }
                },
                {
                    id: 'free-skill-title',
                    state: {
                        fontSize: '24px',
                        lineHeight: '1.3',
                        bold: 'true',
                        title: 'awesome noddy hub'
                    }
                },
                {
                    id: 'canvas-container',
                    state: {
                        direction: 'row',
                        justify: 'space-between'
                    },
                    children: [
                        {
                            id: 'free-skill-publisher',
                            state: {
                                publisher: 'Rocky',
                                fontSize: '14px',
                                lineHeight: '1.35',
                                fontColor: '#0F1111'
                            }
                        },
                        {
                            id: 'average-customer-reviews',
                            state: {
                                averageOverallRating: '4.1',
                                totalRatingCount: '9000'
                            }
                        }
                    ]
                },
                {
                    id: 'free-skill-maturity-rating',
                    state: {
                        ratedCopy: 'Rated',
                        fontSize: '15px',
                        lineHeight: '30px',
                        modalButtonCopy: 'I understand',
                        modalHeaderCopy: 'Rating Definitions'
                    }
                },
                {
                    id: 'canvas-container',
                    state: {
                        direction: 'row',
                        justify: 'center'
                    },
                    children: [
                        {
                            id: 'alexa-free-skill-logo',
                            state: {
                                imageWidth: '200px',
                                imageMargin: '15px 0px 15px 0px',
                                altText: 'awesome noddy hub',
                                title: 'awesome noddy hub',
                                imageHeight: '200px',
                                imageUrl: 'https://images-na.ssl-images-amazon.com/images/I/41ltokWUhJL.png'
                            }
                        }
                    ]
                },
                {
                    id: 'free-to-enable',
                    state: {
                        copy: 'Free to Enable'
                    }
                },
                {
                    id: 'in-skill-purchases-available',
                    state: {
                        inSkillPurchaseCopy: 'In-Skill Purchases Available',
                        hasInSkillPurchases: false,
                        isCenterAligned: true
                    }
                },
                {
                    id: 'utterance-bubbles-mobile',
                    state: {
                        defaultLocale: 'en-US',
                        utterancesByLocale: {
                            'es-MX': [
                                'Alexa, abre Sonidos para Dormir',
                                'Alexa, pide a Sonidos para Dormir lluvia',
                                'Alexa, pide a Sonidos para Dormir una lista'
                            ],
                            'en-GB': [
                                'Alexa, open Sleep Sounds',
                                'Alexa, ask Sleep Sounds for thunderstorms',
                                'Alexa, ask Sleep Sounds for a list'
                            ],
                            'en-US': [
                                'Alexa, open Sleep Sounds',
                                'Alexa, ask Sleep Sounds for thunderstorms',
                                'Alexa, ask Sleep Sounds for a list'
                            ],
                            'fr-CA': [
                                'Alexa, lance Sons Sommeil',
                                'Alexa, demande à Sons Sommeil de jouer des orages',
                                'Alexa, ouvre Sons Sommeil'
                            ],
                            'de-DE': [
                                'Alexa, starte Einschlafgeräusche',
                                'Alexa, frage Einschlafgeräusche nach Regenschauer',
                                'Alexa, spiele Ozeanwellen von Einschlafgeräusche'
                            ],
                            'fr-FR': [
                                'Alexa, lance Sons Sommeil',
                                'Alexa, demande à Sons Sommeil de jouer des orages',
                                'Alexa, ouvre Sons Sommeil'
                            ],
                            'en-CA': [
                                'Alexa, open Sleep Sounds',
                                'Alexa, ask Sleep Sounds for thunderstorms',
                                'Alexa, ask Sleep Sounds for a list'
                            ],
                            'en-AU': [
                                'Alexa, open Sleep Sounds',
                                'Alexa, ask Sleep Sounds for thunderstorms',
                                'Alexa, ask Sleep Sounds for a list'
                            ],
                            'pt-BR': [
                                'Alexa, abra Sons para Dormir',
                                'Alexa, fale com Sons para Dormir para tocar tempestade',
                                'Alexa, abre Sons para Dormir para uma lista'
                            ],
                            'ja-JP': [
                                'アレクサ、睡眠の音を開いて',
                                'アレクサ、睡眠の音をスタートして',
                                'アレクサ、睡眠の音を実行して'
                            ],
                            'es-ES': [
                                'Alexa, abre Sonidos para Dormir',
                                'Alexa, pide a Sonidos para Dormir lluvia',
                                'Alexa, pide a Sonidos para Dormir una lista'
                            ],
                            'en-IN': [
                                'Alexa, open Sleep Sounds',
                                'Alexa, ask Sleep Sounds for thunderstorms',
                                'Alexa, ask Sleep Sounds for a list'
                            ],
                            'es-US': [
                                'Alexa, abre Sonidos para Dormir',
                                'Alexa, pide a Sonidos para Dormir lluvia',
                                'Alexa, pide a Sonidos para Dormir una lista'
                            ],
                            'it-IT': [
                                'Alexa, apri Rumori per Dormire',
                                'Alexa, domanda a Rumori per Dormire di farmi sentire i temporali',
                                'Alexa, chiedi a Rumori per Dormire un elenco'
                            ]
                        },
                        shownInCopy: 'Shown In',
                        languagesByLocale: {
                            'es-MX': 'Spanish (MX)',
                            'en-GB': 'English (GB)',
                            'en-US': 'English (US)',
                            'fr-CA': 'French (CA)',
                            'de-DE': 'German (DE)',
                            'fr-FR': 'French (FR)',
                            'en-CA': 'English (CA)',
                            'en-AU': 'English (AU)',
                            'pt-BR': 'Portugese (BR)',
                            'ja-JP': 'Japanese (JP)',
                            'es-ES': 'Spanish (ES)',
                            'en-IN': 'English (IN)',
                            'it-IT': 'Italy (IT)'
                        },
                        seeAllSupportedLanguagesCopy: 'See all supported languages'
                    }
                },
                {
                    id: 'about-this-item',
                    state: {
                        about: 'About this item'
                    }
                },
                {
                    id: 'canvas-container',
                    state: {
                        border: '1px solid #e7e7e7',
                        padding: '13px 17px 12px 17px'
                    },
                    children: [
                        {
                            id: 'skill-product-description',
                            state: {
                                description: 'This skills will help you to schedule appointment.',
                                maxHeight: '200px',
                                titleCopy: 'Description',
                                seeMoreCopy: 'See More',
                                seeLessCopy: 'See Less'
                            }
                        }
                    ]
                },
                {
                    id: 'canvas-container',
                    state: {
                        border: '1px solid #e7e7e7',
                        padding: '13px 17px 12px 17px'
                    },
                    children: [
                        {
                            id: 'skill-details',
                            state: {
                                invocationNameCopy: 'Invocation Name',
                                developerTermsOfUseCopy: 'Developer Terms of Use',
                                developerPrivacyPolicyCopy: 'Developer Privacy Policy',
                                titleFontSize: '18px',
                                titleCopy: 'Skill Details',
                                developerPrivacyPolicyUrl: 'https://babarpramod.github.io/',
                                dynamicContentProps: {
                                    dynamicContentContains: 'This skill contains',
                                    dynamicContentWarning: 'This skill contains dynamic content, which is content that is updated real-time based on inputs from the developer.',
                                    dynamicContentModalTitle: 'Dynamic Content',
                                    dynamicContentModalButtonCopy: 'I understand',
                                    dynamicContentLowerCase: 'dynamic content'
                                },
                                micTimeoutProps: {
                                    micTimeoutCanExtend: 'This skill can extend the',
                                    micTimeoutLowerCase: 'mic timeout',
                                    micTimeoutModalTitle: 'Mic Timeout',
                                    micTimeoutModalUnderstand: 'I understand',
                                    micTimeoutDescription: "Mic timeout is the period Alexa is listening when it's your turn to respond. This skill can give you more time to respond, up to 10 seconds."
                                },
                                developerTermsOfUseUrl: 'https://babarpramod.github.io/',
                                invocationNameValue: 'awesome noddy hub'
                            }
                        }
                    ]
                },
                {
                    id: 'privacy',
                    state: {
                        titleCopy: 'Privacy',
                        privacyMessage: 'The developer has reported that this skill does not collect personal information.'
                    }
                },
                {
                    id: 'in-skill-purchases',
                    state: {
                        listLineHeight: '25px',
                        isMobile: true
                    }
                },
                {
                    id: 'canvas-container',
                    state: {
                        border: '1px solid #e7e7e7',
                        padding: '13px 17px 12px 17px'
                    },
                    children: [
                        {
                            id: 'free-skill-skill-permissions',
                            state: {
                                titleCopy: 'Skill Permissions',
                                descriptionCopy: 'This skill needs permission to access:',
                                permissionNames: ['Full Name', 'Email Address', 'Mobile Number']
                            }
                        }
                    ]
                },
                {
                    id: 'canvas-container',
                    state: {
                        border: '1px solid #e7e7e7',
                        padding: '13px 17px 12px 17px'
                    },
                    children: [
                        {
                            id: 'free-skill-supported-languages',
                            state: {
                                titleLineHeight: '1.25',
                                languages: ['English (AU)', 'English (CA)', 'English (GB)', 'English (IN)', 'English (US)'],
                                titleFontSize: '18px',
                                titleCopy: 'Supported Languages'
                            }
                        }
                    ]
                }
            ]
        },
        {
            id: 'customer-reviews-medley',
            state: {
                html: '<span id="cr-state-object" data-state=\'{"asin":"B09B4HPDC5","customerId":"0","deviceType":"mobile","contextId":"","reviewCommentsAjaxUrl":"","reviewCommentSubmissionAjaxUrl":"","approvedAuthorAjaxUrl":"","reviewsAjaxUrl":"/hz/reviews-render/ajax/mobley-filtered-reviews/get/","medleyReviewsAjaxUrl":"/hz/reviews-render/ajax/medley-reviews/get/","reviewerType":"","formatType":"","filterByKeyword":"","filterByLanguage":"","filterByStar":"","filterByHeight":"","filterByWeight":"","showLanguageFilter":false,"showHeightFilter":false,"languageOfPreference":"en_US","isCardTreatmentEnabled":false,"lazyWidgetLoaderBufferPixels":"1000","lazyWidgetLoaderDelayBeforeTriggering":"5000","lazyWidgetLoaderUrl":"/hz/reviews-render/ajax/lazy-widgets/stream","lazyWidgetCsrfToken":"gjtY1IJyTRWPhzQIhYLOsgEIh%2BZqmykzKmKiV5YAAAABAAAAAGFItedyYXcAAAAA%2B4kUEk%2F7iMGR3xPcX6iU","lazyWidgetDomainWhitelist":["amazon.com","amazon.ca","amazon.com.mx","amazon.com.br","amazon.co.uk","amazon.de","amazon.it","amazon.sa","amazon.com.tr","amazon.es","amazon.fr","amazon.in","amazon.ae","amazon.nl","amazon.se","amazon.pl","amazon.eg","amazon.co.jp","amazon.com.au","amazon.sg","amazon.cn"],"signinUrl":"https://pre-prod.amazon.com/ap/signin?openid.return_to\\u003dhttps%3A%2F%2Fadg-lpproxysvc-gamma-na-backend.iad.amazon.com%2FRocky-awesome-noddy-hub%2Fproduct-reviews%2FB09B4HPDC5%3Fie%3DUTF8\\u0026openid.identity\\u003dhttp%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select\\u0026openid.claimed_id\\u003dhttp%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select\\u0026openid.assoc_handle\\u003dusflex\\u0026openid.mode\\u003dcheckid_setup\\u0026openid.ns\\u003dhttp%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0","reftagTriggerUrl":"/hz/reviews-render/ajax/reftag-trigger","mobileImageGalleryUrl":"/hz/reviews-render/ajax/mobile-image-gallery/","productInfoUrl":"","disableScroll":false,"onLoadShowHideElements":"#cm-cr-dp-reviews-loading-wrapper,.cr-reviews-loading","marketplaceId":"ATVPDKIKX0DER","locale":"en_US"}\'></span>\n<link rel="stylesheet" href="https://images-na.ssl-images-amazon.com/images/I/01XDT8wnNDL._RC|01KOr0hNn9L.css_.css?AUIClients/MobleyMetaAsset&A1OTnFll#mobile.312430-T1" />\n<script>\n  (window.AmazonUIPageJS ? AmazonUIPageJS : P).load.js(\'https://images-na.ssl-images-amazon.com/images/I/41oUfyds6xL._RC|01yn3tt9zhL.js_.js?AUIClients/MobleyMetaAsset&A1OTnFll#mobile.312430-T1\');\n</script>\n<style>\n  .cr-full-screen-width {\n    position                : relative;\n    width                   : 100vw;\n    left    : calc(-50vw + 50%);\n  }\n\n  .card-padding {\n    padding-right : 6px;\n    padding-left  : 6px;\n  }\n\n  .cr-reviews-count-negate-bottom-padding {\n    padding-bottom: 0;\n    margin-bottom: -5px;\n  }\n\n  .cr-selected-filters-negate-bottom-padding {\n      padding-bottom: 0px;\n      margin-bottom: -15px;\n  }\n\n  </style><div class="a-popover-preload" id="a-popover-cr-media-gallery-popover"><div id="cr-media-gallery-popover">\n    <div class="cr-media-spinner-container">\n      <span class="a-spinner a-spinner-medium cr-media-spinner"></span></div>\n    <div id="cr-media-gallery-container" class="a-section"></div></div>\n</div><a id="customerReviews" aria-label="Customer reviews" class="a-link-normal" href="#customerReviews"></a><div id="aw-udpv3-customer-reviews_feature_div" data-hook="reviews-mobile-widget" class="a-section a-spacing-large customerReviewsMobileFeature"><hr id="cm_cr_dpwidget" aria-hidden="true" class="a-spacing-large a-divider-normal cr-full-screen-width"/><span class="cr-widget-Acr" data-hook="cr-widget-Acr"></span>\n  <span class="cr-lazy-widget cr-summarization-attributes" data-widget-name=\'cr-summarization-attributes\'>\n</span><span class="cr-lazy-widget cr-age-recommendation" data-widget-name=\'cr-age-recommendation\'>\n</span><span class="cr-widget-MedleyCustomerImages" data-hook="cr-widget-MedleyCustomerImages"></span>\n  <span class="cr-lazy-widget cr-summarization-lighthut" data-widget-name=\'cr-summarization-lighthut\'>\n</span><div id="cm-cr-filters" class="celwidget" data-hook="reviews-filter-widget">\n  </div>\n<span class="cr-widget-FocalReviews" data-hook="cr-widget-FocalReviews"></span>\n  <span class="cr-lazy-widget cr-arp-link" data-widget-name=\'cr-arp-link\'>\n</span><span class="cr-widget-MobileGlobalReviews" data-hook="cr-widget-MobileGlobalReviews"></span>\n  <span class="cr-lazy-widget cr-solicitation" data-widget-name=\'cr-solicitation\'>\n</span></div>'
            }
        }
    ]
};
const alexaMonetizedSkillsDetailPageComponentDefinition = {
    id: 'canvas-container',
    state: { direction: 'column' },
    children: [
        {
            id: 'alexa-monetized-skill-meta-tag',
            state: {
                description: 'Samuel L. Jackson - celebrity voice for Alexa',
                pageTitle: 'Amazon.com: Samuel L. Jackson - celebrity voice for Alexa : Alexa Skills',
                productTitle: 'Samuel L. Jackson - celebrity voice for Alexa',
                imageUrl: 'https://images-na.ssl-images-amazon.com/images/I/71RF6ia9xmL.png'
            }
        },
        {
            id: 'canvas-container',
            state: { padding: '14px 18px' },
            children: [
                {
                    id: 'breadcrumbs',
                    state: {
                        breadcrumbs: [
                            { name: 'Alexa Skills', url: '/b?node=13727921011' },
                            { name: 'Novelty & Humor', url: '/b?node=14284858011' }
                        ]
                    }
                }
            ]
        },
        {
            id: 'canvas-container',
            state: { direction: 'column', padding: '16px 16px, 0px 16px', margin: '0 auto', maxWidth: '1260px' },
            children: [
                {
                    id: 'canvas-container',
                    state: { margin: '10px 0px 0px 0px', wrap: 'nowrap' },
                    children: [
                        {
                            id: 'canvas-item',
                            children: [
                                {
                                    id: 'alexa-monetized-skill-logo',
                                    state: {
                                        imageWidth: '210px',
                                        imageMargin: '0px 20px 20px 0px',
                                        altText: 'Samuel L. Jackson - celebrity voice for Alexa',
                                        title: 'Samuel L. Jackson - celebrity voice for Alexa',
                                        imageHeight: '210px',
                                        imageUrl: 'https://images-na.ssl-images-amazon.com/images/I/71RF6ia9xmL.png'
                                    }
                                }
                            ]
                        },
                        {
                            id: 'canvas-container',
                            state: { item: true, xs: true, maxWidth: '730px', minWidth: '230px', margin: '0px 30px 0px 0px' },
                            children: [
                                {
                                    id: 'canvas-container',
                                    state: { margin: '0px 0px 0px 10px', direction: 'column', item: true, xs: true },
                                    children: [
                                        {
                                            id: 'alexa-monetized-skill-title',
                                            state: { title: 'Samuel L. Jackson - celebrity voice for Alexa' }
                                        },
                                        { id: 'alexa-monetized-skill-publisher', state: { publisher: 'Amazon', byText: 'by' } },
                                        {
                                            id: 'alexa-monetized-skill-maturity-rating',
                                            state: {
                                                ratedCopy: 'Rated',
                                                modalButtonCopy: 'I understand',
                                                modalHeaderCopy: 'Rating Definitions'
                                            }
                                        },
                                        {
                                            id: 'average-customer-reviews',
                                            state: {
                                                html: '<span class="dpLaunchpadFullAcrSAMJACKSON"><span><a class="a-link-normal" href="/review/create-review/ref=acr_dplaunchpadfullacr_solicit?ie=UTF8&amp;asin=SAMJACKSON">Be the first to write a review</a></span></span>'
                                            }
                                        },
                                        { id: 'alexa-monetized-skill-price', state: { price: '$4.99' } },
                                        {
                                            id: 'alexa-monetized-skill-isp-available',
                                            state: {
                                                inSkillPurchaseCopy: 'In-Skill Purchases Available',
                                                hasInSkillPurchases: false,
                                                isCenterAligned: false
                                            }
                                        },
                                        {
                                            id: 'alexa-monetized-skill-utterance-bubbles-desktop',
                                            state: {
                                                defaultLocale: 'en-US',
                                                utterancesByLocale: {
                                                    'en-US': [
                                                        '”Alexa, introduce me to Samuel L. Jackson”',
                                                        '”Hey Samuel, what’s the weather?”',
                                                        '”Hey Samuel, roast me!”'
                                                    ]
                                                },
                                                shownInCopy: 'Shown in:',
                                                languagesByLocale: { 'en-US': 'English (US)' },
                                                seeAllSupportedLanguagesCopy: 'See all supported languages'
                                            }
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            id: 'canvas-container',
                            state: { direction: 'column', width: 'auto', item: true },
                            children: [
                                {
                                    id: 'alexa-monetized-skill-buy-box',
                                    state: {
                                        isAuthenticatedUser: true,
                                        signInCopy: 'Sign In',
                                        headingCopy: 'Get this Skill',
                                        footerCopy: 'Sold by Amazon.com Services LLC. Additional taxes may apply. By placing your order, you agree to the <a target="_blank" href="https://www.amazon.com/gp/help/customer/display.html?nodeId=201809740">Alexa Terms of Use</a>.',
                                        actionBoxData: {
                                            priceInfoData: {
                                                additionalPriceText: 'Save $2.00 (40%) off $4.99 list price. One-time purchase.'
                                            },
                                            getStartedWithAlexaButttonCopy: 'Get Started with Alexa',
                                            deviceLocaleWarningMessage: 'This skill is not available with your <span class="a-text-bold">device language settings.</span>',
                                            getStartedButttonCopy: 'Get started with Sam',
                                            getStartedWithALexaUrl: 'https://www.amazon.com/Amazon-Echo-And-Alexa-Devices/b/?ie=UTF8&node=9818047011&ref_=sv_devicesubnav_1',
                                            buyButtonCopy: 'Buy now with 1-Click',
                                            isPaidSkillEntitled: false,
                                            isRegisteredAlexaCustomer: true,
                                            hasValidDeviceLocale: true,
                                            getStartedUrl: 'https://www.amazon.com/b?node=20591210011'
                                        },
                                        compatibilityWidgetData: {
                                            deviceInfoURL: 'https://www.amazon.com/gp/help/customer/display.html/ref=hp_200127470_c?nodeId=GHRYQ6GHE4A5TUD2',
                                            compatibilityPopoverText: 'Works with your Alexa devices.',
                                            popoverContentList: [
                                                'The "Hey Samuel" feature is available on:',
                                                '',
                                                'Echo (2nd, 3rd and 4th gen)',
                                                'Echo Dot (2nd, 3rd and 4th gen)',
                                                'Echo Input',
                                                'Echo Plus (1st and 2nd gen)',
                                                'Echo Flex',
                                                'Echo Dot with Clock',
                                                'Echo Studio',
                                                'Echo Show (1st and 2nd gen)',
                                                'Echo Show 5',
                                                'Echo Show 8',
                                                'Echo Show 10',
                                                'Echo Spot',
                                                '',
                                                'Users without one of the above devices can use "Alexa, ask Samuel"',
                                                '\n'
                                            ],
                                            deviceInfoText: 'Which Echo device do I have?'
                                        }
                                    }
                                },
                                {
                                    id: 'alexa-monetized-skill-share',
                                    state: {
                                        shareUrl: 'https://amazon.com/dp/SAMJACKSON',
                                        message: 'I thought you might be interested in this Alexa skill.',
                                        subject: 'You might be interested in this Alexa skill from Amazon.',
                                        imageUrl: 'https://images-na.ssl-images-amazon.com/images/I/71RF6ia9xmL.png'
                                    }
                                }
                            ]
                        }
                    ]
                },
                {
                    id: 'canvas-container',
                    state: {
                        margin: '10px 0px 22px 0px',
                        borderTop: '1px solid #e7e7e7',
                        padding: '14px 0px 0px 0px'
                    },
                    children: [
                        {
                            id: 'alexa-monetized-skill-highlights',
                            state: {
                                titleCopy: 'Skill Highlights',
                                showPaginationButtons: true,
                                deviceType: 'DESKTOP',
                                mediaWidgetProps: [
                                    {
                                        mediaSrcType: 1,
                                        mediaUrl: 'https://images-na.ssl-images-amazon.com/images/I/41Id9W41ZWS.jpg'
                                    },
                                    {
                                        mediaSrcType: 1,
                                        mediaUrl: 'https://images-na.ssl-images-amazon.com/images/I/41Id9W41ZWS.jpg'
                                    },
                                    {
                                        mediaSrcType: 1,
                                        mediaUrl: 'https://images-na.ssl-images-amazon.com/images/I/41Id9W41ZWS.jpg'
                                    },
                                    {
                                        mediaSrcType: 1,
                                        mediaUrl: 'https://images-na.ssl-images-amazon.com/images/I/41Id9W41ZWS.jpg'
                                    },
                                    {
                                        mediaSrcType: 1,
                                        mediaUrl: 'https://images-na.ssl-images-amazon.com/images/I/41Id9W41ZWS.jpg'
                                    },
                                    {
                                        mediaSrcType: 2,
                                        mediaUrl: 'https://images-na.ssl-images-amazon.com/images/I/F1ylf204aZS.mp4',
                                        featureFrameUrl: 'https://drive.corp.amazon.com/view/kusharju@/CR_Images/StoryBook/Alexa_Logo.png'
                                    }
                                ],
                                videosTabTitleCopy: 'VIDEOS',
                                imagesTabTitleCopy: 'IMAGES',
                                skillTitleCopy: 'Samuel L. Jackson - celebrity voice for Alexa',
                                skillDeveloperNameCopy: 'Amazon',
                                byTextCopy: 'by',
                                videoHoverText: 'Click to see video',
                                imageHoverText: 'Click to open expanded view'
                            }
                        }
                    ]
                },
                {
                    id: 'canvas-container',
                    state: { margin: '10px 0px 22px 0px', borderTop: '1px solid #e7e7e7', padding: '14px 0px 0px 0px' },
                    children: [
                        {
                            id: 'alexa-monetized-skill-product-description',
                            state: {
                                description: 'WHAT’S NEW – 9/16/20: We heard you loud and clear! Samuel L. Jackson celebrity voice just got easier to use. Now you can simply say "Hey Samuel" to ask for jokes, weather, and more. If you\'re new to the voice, just say, “Alexa, introduce me to Samuel L. Jackson” and choose the “Hey Samuel” wake word. You will still be able to use Alexa’s default voice just as you do now. Check below to see if your device works with “Hey Samuel”.\n\nAlready have Samuel L. Jackson celebrity voice? You can set up “Hey Samuel” by saying “Alexa, enable ‘Hey Samuel’”.\n\n\nGET STARTED WITH SAMUEL – Samuel L. Jackson is here to add extra personality to your Alexa experience. Just ask and Samuel will set a timer, tell you a story, and more.\n\nKEEP IT CLEAN, OR DON’T – Choose whether you’d like Samuel to use explicit language or not. If you change your mind later, simply say “Alexa enable Hey Samuel” to turn explicit content on or off.\n\nASK AWAY – After purchasing, try saying:\n\n“Hey Samuel, what’s the weather?”\n“Hey Samuel, tell me a joke.”\n“Hey Samuel, set an alarm for 7am.”\n“Hey Samuel, tell me a story.”\n"Hey Samuel, what can you do?"\n“Alexa, ask Samuel to give me advice.”\n“Alexa, ask Samuel what he thinks of snakes.”\n\nDOES MY DEVICE WORK WITH “HEY SAMUEL”? The “Hey Samuel” wake word works for most voice-activated Echo devices in your home, except first-generation Echo and Echo Dot and wearables. Fire TV and Fire Tablets will be supported at a later time. Once you turn on his wake word, Samuel will respond when you say his whole first name, “Hey Samuel”. Users without a compatible device can use “Alexa, ask Samuel”.\n\nWE WANT YOU TO KNOW – Although he can do a lot, Samuel won’t be able to help with Shopping, lists, reminders or Skills.',
                                titleCopy: 'Description',
                                seeMoreCopy: 'See More',
                                seeLessCopy: 'See Less'
                            }
                        },
                        {
                            id: 'canvas-container',
                            state: {
                                padding: '20px 0px 0px 0px'
                            },
                            children: [
                                {
                                    id: 'alexa-monetized-skill-video',
                                    state: {
                                        videoSrc: 'https://m.media-amazon.com/images/G/01/skillstore/jasmine/walkenv2video.mp4',
                                        posterURL: 'https://m.media-amazon.com/images/G/01/skillstore/jasmine/walkenv2poster.jpg'
                                    }
                                }
                            ]
                        },
                        {
                            id: 'alexa-monetized-skill-media',
                            state: {
                                medias: [
                                    {
                                        imageContent: {
                                            url: 'https://m.media-amazon.com/images/G/01/skillstore/jasmine/jasmineImage1.jpg',
                                            title: 'Samuel L. Jackson is here to help',
                                            altText: 'You ask about weather and Samuel L. Jackson tells you Mother Nature is angry'
                                        },
                                        textContent: {
                                            header: 'Ask away',
                                            text: 'Samuel L. Jackson can help you set a timer, serenade you with a song, tell you a funny joke, and more. Get to know him a little better by asking about his interests and career.'
                                        }
                                    },
                                    {
                                        imageContent: {
                                            url: 'https://m.media-amazon.com/images/G/01/skillstore/jasmine/jasmineImage2.jpg',
                                            title: 'https://m.media-amazon.com/images/G/01/skillstore/jasmine/jasmineImage2.jpg',
                                            altText: 'Amazon Echo dot with censored language'
                                        },
                                        textContent: {
                                            header: 'Keep it clean, or don’t',
                                            text: 'After purchasing the feature, you choose whether you’d like Sam to use explicit language or not. If you ever change your mind, you can toggle between clean and explicit content in the settings menu of the Alexa App.'
                                        }
                                    },
                                    {
                                        imageContent: {
                                            url: 'https://m.media-amazon.com/images/G/01/skillstore/jasmine/jasmineImage3.jpg',
                                            title: 'Get started',
                                            altText: 'Default Alexa icon'
                                        },
                                        textContent: {
                                            header: 'Get started',
                                            text: '1. Say "Alexa, introduce me to Samuel L. Jackson."<br>2. Confirm your purchase with Alexa.<br>3. Enable or disable explicit content.<br>4. Ask Samuel L. Jackson for music, weather and more.'
                                        }
                                    }
                                ]
                            }
                        }
                    ]
                },
                {
                    id: 'canvas-container',
                    state: { margin: '10px 0px 22px 0px', borderTop: '1px solid #e7e7e7', padding: '14px 0px 0px 0px' },
                    children: [
                        {
                            id: 'alexa-monetized-skill-details',
                            state: {
                                invocationNameCopy: 'Invocation Name',
                                developerTermsOfUseCopy: 'Developer Terms of Use',
                                developerPrivacyPolicyCopy: 'Developer Privacy Policy',
                                titleCopy: 'Skill Details',
                                developerPrivacyPolicyUrl: 'https://www.amazon.com/gp/help/customer/display.html?nodeId=468496',
                                dynamicContentProps: {
                                    dynamicContentContains: 'This skill contains',
                                    dynamicContentWarning: 'This skill contains dynamic content, which is content that is updated real-time based on inputs from the developer.',
                                    dynamicContentModalTitle: 'Dynamic Content',
                                    dynamicContentModalButtonCopy: 'I understand',
                                    dynamicContentLowerCase: 'dynamic content'
                                },
                                micTimeoutProps: {
                                    micTimeoutCanExtend: 'This skill can extend the',
                                    micTimeoutLowerCase: 'mic timeout',
                                    micTimeoutModalTitle: 'Mic Timeout',
                                    micTimeoutModalUnderstand: 'I understand',
                                    micTimeoutDescription: "Mic timeout is the period Alexa is listening when it's your turn to respond. This skill can give you more time to respond, up to 10 seconds."
                                },
                                developerTermsOfUseUrl: 'https://www.amazon.com/gp/help/customer/display.html?nodeId=201809740',
                                invocationNameValue: 'Alexa, introduce me to Samuel L. Jackson',
                                smartHomeSkillProps: {
                                    smartHomeSkillIntro: 'Smart Home Skill. This skill may share device information with Amazon.',
                                    smartHomeSkillLearnMore: 'Learn more',
                                    smartHomeSkillLearnMoreUrl: '/gp/help/customer/display.html?nodeId=201602230'
                                }
                            }
                        }
                    ]
                },
                { id: 'alexa-monetized-skill-in-skill-purchases', state: {} },
                {
                    id: 'canvas-container',
                    state: { margin: '0px 0px 22px 0px', borderTop: '1px solid #e7e7e7', padding: '14px 0px 0px 0px' },
                    children: [
                        {
                            id: 'alexa-monetized-skill-supported-languages',
                            state: { languages: ['English (US)'], titleCopy: 'Supported Languages' }
                        }
                    ]
                },
                {
                    id: 'canvas-container',
                    children: [
                        {
                            id: 'customer-reviews-medley',
                            state: {
                                html: '<a id="customerReviews" aria-label="Top reviews" class="a-link-normal" href="#"></a><hr aria-hidden="true" class="a-spacing-large a-divider-normal"/><span class="cr-widget-PageState">\n  <span id="cr-state-object" data-state=\'{"asin":"SAMJACKSON","customerId":"0","deviceType":"desktop","contextId":"","reviewCommentsAjaxUrl":"","reviewCommentSubmissionAjaxUrl":"","approvedAuthorAjaxUrl":"","reviewsAjaxUrl":"/hz/reviews-render/ajax/medley-filtered-reviews/get/","medleyReviewsAjaxUrl":"/hz/reviews-render/ajax/medley-reviews/get/","reviewerType":"","formatType":"","filterByKeyword":"","filterByLanguage":"","filterByStar":"","filterByHeight":"","filterByWeight":"","showLanguageFilter":false,"showHeightFilter":false,"languageOfPreference":"en_US","isCardTreatmentEnabled":false,"lazyWidgetLoaderBufferPixels":"1000","lazyWidgetLoaderDelayBeforeTriggering":"5000","lazyWidgetLoaderUrl":"/hz/reviews-render/ajax/lazy-widgets/stream","lazyWidgetCsrfToken":"gpZZfqG2uk0Er5o9bjMbQkK0MYCrd5p9jJXlB7MAAAABAAAAAGDj0iByYXcAAAAA%2B4kUEk%2F7iMGR3xPcX6iU","lazyWidgetDomainWhitelist":["amazon.com","amazon.ca","amazon.com.mx","amazon.com.br","amazon.co.uk","amazon.de","amazon.it","amazon.sa","amazon.com.tr","amazon.es","amazon.fr","amazon.in","amazon.ae","amazon.nl","amazon.se","amazon.pl","amazon.eg","amazon.co.jp","amazon.com.au","amazon.sg","amazon.cn"],"signinUrl":"https://development.amazon.com/ap/signin?openid.return_to\\u003dhttps%3A%2F%2Fadg-lpproxysvc-beta-na-backend.integ.amazon.com%2Fproduct-reviews%2FSAMJACKSON%3Fie%3DUTF8\\u0026openid.identity\\u003dhttp%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select\\u0026openid.claimed_id\\u003dhttp%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select\\u0026openid.assoc_handle\\u003dusflex\\u0026openid.mode\\u003dcheckid_setup\\u0026openid.ns\\u003dhttp%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0","reftagTriggerUrl":"/hz/reviews-render/ajax/reftag-trigger","mobileImageGalleryUrl":"","productInfoUrl":"","disableScroll":false,"onLoadShowHideElements":"#cm-cr-dp-reviews-loading-wrapper,.cr-reviews-loading"}\'></span>\n</span>\n<link rel="stylesheet" href="https://images-na.ssl-images-amazon.com/images/I/01STrEog8JL._RC|015DCfR+jFL.css,01LKsGfpclL.css,21cDvZoGyBL.css,01cdXa5nSoL.css_.css?AUIClients/DesktopMedleyFilteringMetaAsset" />\n<script>\n  (window.AmazonUIPageJS ? AmazonUIPageJS : P).load.js(\'https://images-na.ssl-images-amazon.com/images/I/414YATFBD+L._RC|01TvTYLyWBL.js,11PLCo6zxLL.js,21P7JGewuJL.js,21HWbFKuvXL.js_.js?AUIClients/DesktopMedleyFilteringMetaAsset\');\n</script>\n<div id="reviewsMedley" data-hook="reviews-medley-widget" class="a-fixed-left-grid a-spacing-extra-large"><div class="a-fixed-left-grid-inner" style="padding-left:300px"><div class="a-fixed-left-grid-col a-col-left" style="width:300px;margin-left:-300px;float:left;"><div class="a-row"><h2>Customer Reviews</h2></div><div class="a-section a-spacing-none a-spacing-top-mini cr-widget-ACR"></div><span class="cr-widget-Histogram">\n      <div class="a-fixed-left-grid a-spacing-none"><div class="a-fixed-left-grid-inner" style="padding-left:280px"><div class="a-fixed-left-grid-col a-col-left" style="width:280px;margin-left:-280px;float:left;"><span class="a-declarative" data-action="reviews:filter-action:push-state" data-reviews:filter-action:push-state="{&quot;scrollToSelector&quot;:&quot;#reviews-filter-info&quot;,&quot;allowLinkDefault&quot;:&quot;1&quot;}"><table id="histogramTable" class="a-normal a-spacing-none" role="presentation">\n\n\n\n\n\n\n\n\n<table id="histogramTable" class="a-normal a-align-center a-spacing-base">\n  \n\n\n\n\n\n\n\n\n\n\n\n\n\n\n  \n    \n  \n  \n\n\n\n\n\n\n\n\n\n\n\n  \n\n    \n    <tr class="a-histogram-row">\n\n      <td class="a-nowrap">\n        <span class="a-size-base">\n          5 star\n        </span>\n\n        \n        <span class="a-offscreen">\n          (0%)\n        </span>\n\n        <span class="a-letter-space"></span>\n      </td>\n\n      <td aria-hidden="true" class="a-span10">\n        <div class="a-meter" role="progressbar" aria-valuenow="0%"><div class="a-meter-bar" style="width: 0%;"></div></div>\n      </td>\n\n      <td class="a-text-right a-nowrap">\n        <span class="a-letter-space"></span>\n\n        <span class="a-size-base">\n          \n            0%\n          \n        </span>\n      </td>\n    </tr>\n\n  \n  \n\n\n  \n\n\n\n\n\n\n\n\n\n\n\n\n\n\n  \n    \n  \n  \n\n\n\n\n\n\n\n\n\n\n\n  \n\n    \n    <tr class="a-histogram-row">\n\n      <td class="a-nowrap">\n        <span class="a-size-base">\n          4 star\n        </span>\n\n        \n        <span class="a-offscreen">\n          (0%)\n        </span>\n\n        <span class="a-letter-space"></span>\n      </td>\n\n      <td aria-hidden="true" class="a-span10">\n        <div class="a-meter" role="progressbar" aria-valuenow="0%"><div class="a-meter-bar" style="width: 0%;"></div></div>\n      </td>\n\n      <td class="a-text-right a-nowrap">\n        <span class="a-letter-space"></span>\n\n        <span class="a-size-base">\n          \n            0%\n          \n        </span>\n      </td>\n    </tr>\n\n  \n  \n\n\n  \n\n\n\n\n\n\n\n\n\n\n\n\n\n\n  \n    \n  \n  \n\n\n\n\n\n\n\n\n\n\n\n  \n\n    \n    <tr class="a-histogram-row">\n\n      <td class="a-nowrap">\n        <span class="a-size-base">\n          3 star\n        </span>\n\n        \n        <span class="a-offscreen">\n          (0%)\n        </span>\n\n        <span class="a-letter-space"></span>\n      </td>\n\n      <td aria-hidden="true" class="a-span10">\n        <div class="a-meter" role="progressbar" aria-valuenow="0%"><div class="a-meter-bar" style="width: 0%;"></div></div>\n      </td>\n\n      <td class="a-text-right a-nowrap">\n        <span class="a-letter-space"></span>\n\n        <span class="a-size-base">\n          \n            0%\n          \n        </span>\n      </td>\n    </tr>\n\n  \n  \n\n\n  \n\n\n\n\n\n\n\n\n\n\n\n\n\n\n  \n    \n  \n  \n\n\n\n\n\n\n\n\n\n\n\n  \n\n    \n    <tr class="a-histogram-row">\n\n      <td class="a-nowrap">\n        <span class="a-size-base">\n          2 star\n        </span>\n\n        \n        <span class="a-offscreen">\n          (0%)\n        </span>\n\n        <span class="a-letter-space"></span>\n      </td>\n\n      <td aria-hidden="true" class="a-span10">\n        <div class="a-meter" role="progressbar" aria-valuenow="0%"><div class="a-meter-bar" style="width: 0%;"></div></div>\n      </td>\n\n      <td class="a-text-right a-nowrap">\n        <span class="a-letter-space"></span>\n\n        <span class="a-size-base">\n          \n            0%\n          \n        </span>\n      </td>\n    </tr>\n\n  \n  \n\n\n  \n\n\n\n\n\n\n\n\n\n\n\n\n\n\n  \n    \n  \n  \n\n\n\n\n\n\n\n\n\n\n\n  \n\n    \n    <tr class="a-histogram-row">\n\n      <td class="a-nowrap">\n        <span class="a-size-base">\n          1 star\n        </span>\n\n        \n        <span class="a-offscreen">\n          (0%)\n        </span>\n\n        <span class="a-letter-space"></span>\n      </td>\n\n      <td aria-hidden="true" class="a-span10">\n        <div class="a-meter" role="progressbar" aria-valuenow="0%"><div class="a-meter-bar" style="width: 0%;"></div></div>\n      </td>\n\n      <td class="a-text-right a-nowrap">\n        <span class="a-letter-space"></span>\n\n        <span class="a-size-base">\n          \n            0%\n          \n        </span>\n      </td>\n    </tr>\n\n  \n  \n\n\n</table>\n</table></span></div></div></div><div aria-live="polite" class="a-row a-expander-container a-spacing-top-small a-expander-inline-container"><a href="javascript:void(0)" data-action="a-expander-toggle" class="a-expander-header a-declarative a-expander-inline-header a-link-expander" data-a-expander-toggle="{&quot;allowLinkDefault&quot;:true, &quot;expand_prompt&quot;:&quot;&quot;, &quot;collapse_prompt&quot;:&quot;&quot;}"><i class="a-icon a-icon-expand"></i><span class="a-expander-prompt">How are ratings calculated?</span></a><div aria-expanded="false" class="a-expander-content a-expander-inline-content a-expander-inner" style="display:none">To calculate the overall star rating and percentage breakdown by star, we don’t use a simple average. Instead, our system considers things like how recent a review is and if the reviewer bought the item on Amazon. It also analyzes reviews to verify trustworthiness.</div></div></span>\n    <hr aria-hidden="true" class="a-spacing-large a-spacing-top-large a-divider-normal"/><span class="cr-lazy-widget cr-summarization-attributes" data-widget-name=\'cr-summarization-attributes\'>\n</span><span class="cr-lazy-widget cr-age-recommendation" data-widget-name=\'cr-age-recommendation\'>\n</span><span class="cr-lazy-widget cr-solicitation" data-widget-name=\'cr-solicitation\'>\n</span><hr aria-hidden="true" class="a-spacing-extra-large a-spacing-top-extra-large a-divider-normal"/></div><div class="a-fixed-left-grid-col a-col-right" style="padding-left:2.5%;float:left;"><div class="a-row cm_cr_grid_center_container"><div class="a-fixed-right-grid-col cm_cr_grid_center_left" style="float:left;"></div><div class="a-fixed-right-grid-col cm_cr_grid_center_right" style="float:left;"><span class="cr-widget-MedleyCustomerImages" data-hook="cr-widget-MedleyCustomerImages"></span>\n  <span class="cr-lazy-widget cr-summarization-lighthut" data-widget-name=\'cr-summarization-lighthut\'>\n</span><div id="cm-cr-dp-review-header" class="a-section a-spacing-small"><h3 class="a-spacing-small"><span data-hook="top-customer-reviews-title" class="a-size-base">No customer reviews</span></h3></div><span class="cr-widget-FocalReviews" data-hook="cr-widget-FocalReviews"></span>\n  <span class="cr-widget-DesktopGlobalReviews" data-hook="cr-widget-DesktopGlobalReviews"></span>\n  </div></div></div></div></div>'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};
